import React from 'react' // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom'

import { Router as App } from './router'

const app = document.getElementById('app')

ReactDOM.render(
  App,
  app
)



/** WEBPACK FOOTER **
 ** ./pub/client/app.js
 **/